module.exports = __webpack_public_path__ + "static/media/inAppLogo.8843bd66.png";